// src/pages/OperatingSystems.js 
// (Assuming this file contains your OperatingSystems component)

import React from 'react';
import { Helmet } from 'react-helmet-async'; // 👈 Import the Helmet component

// Common Components
import Navbar from '../../CommonComponent/Navbar/Navbar'; 
import Footer from '../../CommonComponent/Footer/footer';
import NotificationBar from '../../CommonComponent/Notification/NotificationBar';

// Page Component
import OScontent from './PageComponent/OScontent'


function OperatingSystems() {

    // The useMeta hook call is removed and its content is moved into <Helmet>
    return (
        <>
            <Helmet>
                {/* Primary SEO Tags */}
                <title>Operating Systems | Marvel Blinds</title>
                <meta
                    name="description"
                    content="Explore different types of operating systems and their features. Find the right one for your needs. Start your journey now!"
                />
                <link rel="canonical" href={`${process.env.REACT_APP_WEBSITE_URL}/operating-systems/`} />

                {/* Open Graph Tags (for Social Media) */}
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="Operating Systems" />
                <meta
                    property="og:description"
                    content="Explore different types of operating systems and their features. Find the right one for your needs. Start your journey now!"
                />
                <meta property="og:url" content={`${process.env.REACT_APP_WEBSITE_URL}/operating-systems/`} />
                <meta property="og:site_name" content="Marvel Blinds" />
            </Helmet>

            {/* Rest of your component structure */}
            <div>
                <Navbar />
                <NotificationBar />
                <OScontent />
                <Footer />
            </div>
        </>
    );
}

export default OperatingSystems;